import React, { Component } from 'react';
import { Switch, Route, withRouter, RouteComponentProps } from 'react-router-dom';
import { connect } from 'react-redux';
import { ConnectedPage } from '../Page';
import { Footer } from '../Footer';
import { Help } from '../Help';
import { SelectedBuilding, NavigationParamsType } from '../../store/building/types';
import './Main.css';
import { ConnectedUserManagement } from '../Settings/components/UserManagement/UserManagement';
import { ConnectedProfile } from '../Account/components/Profile';
import { ConnectedUpdatePassword } from '../Account/components/UpdatePassword';

export interface Props extends RouteComponentProps {
  navigationParams: NavigationParamsType;
  selectedBuilding: SelectedBuilding;
  // getBuildingList(): void;
  location: {
    search: string;
    pathname: string;
    state: string;
    hash: string;
  };
}

export class Main extends Component<Props, never> {
  async componentDidMount() {
    // const { getBuildingList } = this.props;
    // await getBuildingList();
    this.redirect();
  }

  redirect() {
    const {
      navigationParams,
      location: { search },
    } = this.props;

    // To handle the old Alert Incidents urls
    if (location.pathname.includes('/incidents')) {
      const oldPathname = location.pathname;
      const newPathname = oldPathname.replace('/incidents', '/alert-incidents');
      this.props.history.replace(`${newPathname}${search}`);
    }

    if (navigationParams.selectedSubCategory) {
      if (navigationParams.selectedSubCategory.url) {
        this.props.history.replace(`${navigationParams.selectedSubCategory.url}${search}`);
      }
    }
  }

  componentDidUpdate(prevProps: Props) {
    const {
      navigationParams: { selectedSubCategory: oldSubCategory },
    } = prevProps;

    const {
      navigationParams: newNavigationParams,
      history,
      location: { search },
      selectedBuilding: { identifier: newIdentifier },
    } = this.props;

    if (!oldSubCategory) {
      // If there is no old subCategory aka first page load
      if (newNavigationParams.selectedSubCategory) {
        if (newNavigationParams.selectedSubCategory.url) {
          return history.push(`${newNavigationParams.selectedSubCategory.url}${search}`);
        }
      }
    } else {
      // If there is an old subCategory and the old url does not match new url
      if (oldSubCategory.url && oldSubCategory.url !== newNavigationParams.selectedSubCategory.url) {
        if (!oldSubCategory.url.includes(newIdentifier)) {
          return history.push(`${newNavigationParams.selectedSubCategory.url}`);
        } else {
          history.push(`${newNavigationParams.selectedSubCategory.url}${search}`);
        }
      } else if (!oldSubCategory.url && newNavigationParams.selectedSubCategory) {
        if (newNavigationParams.selectedSubCategory.url) {
          return history.push(`${newNavigationParams.selectedSubCategory.url}${search}`);
        }
      }
    }
  }

  render() {
    return (
      <div className="main">
        <div className="main__content-wrapper">
          <div className="main__content">
            <div>
              <Switch>
                <Route
                  exact={true}
                  path="/:building/:category/:subcategory"
                  render={(props) => {
                    return (
                      <ConnectedPage
                        building={props.match.params.building}
                        category={props.match.params.category}
                        subcategory={props.match.params.subcategory}
                        key={props.location.pathname + props.location.search}
                      />
                    );
                  }}
                />
                <Route
                  exact={true}
                  path="/help"
                  render={(props) => (
                    <ConnectedPage category="help" key={props.location.pathname}>
                      <Help />
                    </ConnectedPage>
                  )}
                />
                <Route
                  exact={true}
                  path="/account/profile"
                  render={(props) => (
                    <ConnectedPage category="account" subcategory="profile" key={props.location.pathname}>
                      <ConnectedProfile />
                    </ConnectedPage>
                  )}
                />
                <Route
                  exact={true}
                  path="/account/update-password"
                  render={(props) => (
                    <ConnectedPage category="account" subcategory="update-password" key={props.location.pathname}>
                      <ConnectedUpdatePassword />
                    </ConnectedPage>
                  )}
                />
                <Route
                  exact={true}
                  path="/settings/user-management"
                  render={(props) => (
                    <ConnectedPage category="settings" subcategory="user-management" key={props.location.pathname}>
                      <ConnectedUserManagement />
                    </ConnectedPage>
                  )}
                />
              </Switch>
            </div>
            <Footer />
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state: any) {
  return {
    navigationParams: state.buildingReducer.navigationParams,
    selectedBuilding: state.buildingReducer.selectedBuilding,
  };
}

const mapDispatchToProps = {
  // getBuildingList: BuildingActions.getBuildingList,
};

const ConnectedMain = connect(mapStateToProps, mapDispatchToProps)(Main);
const ConnectedMainWithRouter = withRouter(ConnectedMain);
export { ConnectedMainWithRouter };
